// staging || production
const ENV = process.env.REACT_APP_ENV || "production";

export const getUrl = {
  baseURL:
    ENV === "staging"
      ? process.env.REACT_APP_STAGING_URL
      : process.env.REACT_APP_PRODUCTION_URL
};